jQuery(document).ready(function ($) {
  // homepage rotator
  // if (!$('body').hasClass('dnnEditState')) {
  $('.banners').cycle({
    speed: 1500,
    manualSpeed: 100,
    timeout: 8500,
    fx: 'fade',
    manualFx: 'scrollHorz',
    pager: '.banner-pager',
    pagerTemplate: '<span tab-index="0"></span>',
    slides: '.banner',
    swipe: true
  });
  // }
});